import _ProgressConversationsQuery from "../__generated__/ProgressConversationsQuery.graphql";
import { graphql, useLazyLoadQuery } from 'react-relay';
import { Navigate } from 'react-router-dom';
import { getLocale, langOf } from '../i18n/locale';
import { BooksRead } from './BooksRead.tsx';
import { RetellingList } from './RetellingList.tsx';
import { SessionList } from './SessionList.tsx';
import { registerFor } from '../profile/register';
import type { ProgressConversationsQuery as ProgressConversationsQueryType } from '../__generated__/ProgressConversationsQuery.graphql';

/**
 * `first: 20, spoken: true`, matching `ProgressViewQuery` and
 * `AccountHistoryQuery`: one
 * Relay storage key, so moving between the overview and this tab is a store
 * hit rather than a refetch.
 */
const ProgressConversationsQuery = (_ProgressConversationsQuery.hash && _ProgressConversationsQuery.hash !== "f03cf4282c87b10354e132b552982d23" && console.error("The definition of 'ProgressConversationsQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _ProgressConversationsQuery);

/**
 * An adult's past conversations, each opening its debrief, the books they
 * have finished, the list a parent sees on a child's account (amendment
 * 2026-09-29), and their Listen & Write retellings (listen & write design
 * §7), which the server lists for no child.
 *
 * Adult only. A child's debriefs are for a parent and live under
 * `/account/history`; a typed `/history/conversations` goes back to the
 * overview, as `AccountHistory` does the other way round.
 */
export function ProgressConversations() {
  const language = langOf(getLocale());
  // `store-and-network`, as `BookShelf` has it: `finishStory`'s payload
  // updates no `storyReads` list, so a store hit alone would miss the book
  // just finished.
  const data = useLazyLoadQuery<ProgressConversationsQueryType>(ProgressConversationsQuery, {
    language
  }, {
    fetchPolicy: 'store-and-network'
  });
  const learner = data.me?.learner;
  if (registerFor(learner?.defaultCharacter?.audience) === 'kid') return <Navigate to="/history" replace />;
  return <div className="flex flex-col gap-3">
      <SessionList sessions={learner?.sessions?.nodes ?? []} showDebrief />
      <BooksRead reads={learner?.storyReads ?? []} language={language} none="history-books-none-own" />
      <RetellingList retellings={learner?.retellings ?? []} />
    </div>;
}